import React from 'react';
import DriveTopBar from './DriveTopBar';

const DriveWrapper = ({ children }) => {
  return (
    <div className="admin-page">
      <div className="admin-body">
        <DriveTopBar />
        <div className="admin-content">{children}</div>
      </div>
    </div>
  );
};

export default DriveWrapper;
